import React from 'react';
import { render, screen } from '@testing-library/react';

import ConfigProvider from 'components/ConfigProvider';

import UserCell from './UserCell';

const renderCell = (props = {}) =>
  render(
    <ConfigProvider>
      <UserCell
        email="martinez@email.com"
        id={7}
        name="Abe Martinez"
        {...props}
      />
    </ConfigProvider>,
  );

describe('management/Users UserCell', () => {
  it('shows the name', () => {
    renderCell();

    expect(screen.getByText('Abe Martinez')).toBeInTheDocument();
  });

  it('shows the email beneath it', () => {
    renderCell();

    expect(screen.getByText('martinez@email.com')).toBeInTheDocument();
  });

  // Avatar builds itself from the name, which is why no initials come over the
  // wire — see the note in Management::UserRows.
  it('renders an avatar labelled for the user', () => {
    renderCell();

    expect(
      screen.getByRole('img', { name: 'Abe Martinez avatar' }),
    ).toBeInTheDocument();
  });

  it('renders without a name', () => {
    renderCell({ name: undefined });

    expect(screen.getByText('martinez@email.com')).toBeInTheDocument();
  });

  it('links the name to the detail page', () => {
    renderCell();

    expect(screen.getByRole('link', { name: 'Abe Martinez' })).toHaveAttribute(
      'href',
      '/management/users/7/edit',
    );
  });

  // There would be nothing to click, so the link is dropped rather than rendered
  // empty.
  it('does not link a user with no name', () => {
    renderCell({ name: undefined });

    expect(screen.queryByRole('link')).not.toBeInTheDocument();
  });

  // KeyDS Link dies on re-render under React 16, which is why the cell uses a plain
  // styled anchor. A re-render is exactly what the table does on every fetch.
  it('survives a re-render', () => {
    const { rerender } = renderCell();

    rerender(
      <ConfigProvider>
        <UserCell email="martinez@email.com" id={7} name="Abe M Martinez" />
      </ConfigProvider>,
    );

    expect(
      screen.getByRole('link', { name: 'Abe M Martinez' }),
    ).toBeInTheDocument();
  });
});
